import script from "/app/module/error_handler/components/error_zone.vue?type=script";
import { render } from "/app/module/error_handler/components/error_zone.vue?type=template";
script.render = render;
export default script;
